
import * as React from "react";
import { IAddress } from "../../interfaces/IRestaurant";
import { Api } from "../../lib/Api";
import Config from "../../Config";
import { Lng } from "../../../languages/Languages";



export interface ICountryOption{
    label: string
    value: number
}

interface IAddressBoxProps extends IAddress {
    countryOptions       : any
    changed              : Function
    showOnlyCity         ?: boolean
    showOnlyCityLabel    ?: string
    title                ?: string
}

interface IAddressBoxState {
    form    :IAddress
    loading :boolean
}

export default class AddressBox extends React.Component<IAddressBoxProps, IAddressBoxState>{

    apiKey       : string;
    nearlyAddress: any;

	constructor(props:IAddressBoxProps){
        super(props);
        this.apiKey          = Config.getAPIKey();
        this.nearlyAddress   = null;
        this.state = {
            form:{
                addressCountry: this.props.addressCountry,
                addressState  : this.props.addressState,
                addressCity   : this.props.addressCity,
                addressStreet : this.props.addressStreet,
                addressZip    : this.props.addressZip,
            },
            loading       : false
        };
    }

    private changeInputHandler(evt, type:string): void {
        evt.preventDefault();
        let form = this.state.form;
        form[type] = evt.target.value;
        this.setState({
            form: form
        }, () =>{
         //   this.refreshForm();
        });
    }

    private refreshForm():void{
        //this.props.changed(this.state.form);
    }


    private getGeoCordFromAddress():void{
        // get positons

        this.setState({
            loading: true
        }, () =>{

            Api.call('/getGeoCordFromAddress', {
                address: this.state.form.addressCountry + ' ' + this.state.form.addressState + ' ' + this.state.form.addressCity + ', ' + this.state.form.addressStreet + ' ' + this.state.form.addressZip,
                apiKey: this.apiKey
            }, (result)=>{
                let form        = this.state.form;
                form.latitude   = result.latitude;
                form.longitude  = result.longitude;
                this.setState({
                    loading: false
                }, ()=>{
                    this.refreshForm();
                });

            });
        });
    }

    private getGeoLocation():void{
        //get positions

        this.setState({
            loading: true
        }, () =>{
            Api.getGeoLocation((position)=>{
                if ( position !== null ) {
                    let form       = this.state.form;
                    form.longitude = position.coords.longitude.toString();
                    form.latitude  = position.coords.latitude.toString();
                    this.setState({
                            form: form
                    }, () =>{
                        this.getNearlyCity();
                    });
                }else{
                    let form       = this.state.form;
                    if ( form.longitude !== '0' && form.latitude  !== '0' ) {
                        form.longitude = '0';
                        form.latitude  = '0';
                        this.setState({
                                form: form
                        }, () =>{
                            this.getNearlyCity();
                        });
                    }else{
                        this.getNearlyCity();
                    }
                    alert(Lng.get('please_enable_the_geolocation'));
                }
            });
        });

    }

    private getNearlyCity() {
        if ( this.nearlyAddress === null ) {
            Api.call('/getNerlyCity', {
                latitude:  this.state.form.latitude,
                longitude: this.state.form.longitude,
                apiKey: this.apiKey
            }, (result)=>{
                this.nearlyAddress = result;
                this.setNerylAddress();
            });
        }
        this.setNerylAddress();
    }

    private setNerylAddress(){
        if ( this.nearlyAddress !== null ) {
            if ( this.nearlyAddress.results !== undefined  && this.nearlyAddress.results.length > 0  && this.nearlyAddress.results[0].address_components !== undefined ) {
                var address_components = this.nearlyAddress.results[0].address_components;
                let form = this.state.form;
                form.addressStreet = '';
                for (var key in address_components) {
                    var item = address_components[key];
                    if ( item.types.indexOf('street_number') === 0) {
                        form.addressStreet = ' ' + item.short_name;
                    }
                    if ( item.types.indexOf('route') === 0) {
                        form.addressStreet =  item.short_name + form.addressStreet;
                    }
                    if ( item.types.indexOf('locality') === 0) {
                        form.addressCity =  item.short_name;
                    }
                    if ( item.types.indexOf('postal_town') === 0) {
                        form.addressCity =  item.short_name;
                    }
                    if ( item.types.indexOf('postal_code') === 0) {
                        form.addressZip =  item.short_name;
                    }
                    if ( item.types.indexOf('country') === 0) {
                        form.addressCountry =  item.long_name;
                    }
                    if ( item.types.indexOf('state') === 0) {
                        form.addressState =  item.long_name;
                    }

                    this.setState({
                        form:      form,
                        loading:   false
                    }, () =>{
                        this.refreshForm();
                    });
                }

            }
        }
    }

    render() {
        let showOnlyCity            = this.props.showOnlyCity !== undefined && this.props.showOnlyCity===true;
        let title                   = this.props.title!==undefined?this.props.title:Lng.get('address')
;
        let hideTitleColumn:boolean = ( title==='' || title === null );
        return (
            <div className = "address-box">
                { showOnlyCity?<>
                    <div className="form-row">
                        <div className="col-6">
                            <label htmlFor="city">{ this.props.showOnlyCityLabel }</label>
                        </div>
                        <div className="col-6">
                            <button className="btn btn-link" id="get_address_from_location_btn" type="button" onClick={ e => {
                                e.preventDefault();
                                this.getGeoLocation();
                            } }>{ this.state.loading===true?Lng.get('user_handover_loading'):Lng.get('use_my_location') }</button>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="col-12">
                            <input className="s-form-control" type="text" name="city" value={this.state.form.addressCity} onChange={ e => this.changeInputHandler(e,'addressCity') } placeholder={Lng.get('city')} required={true}/>
                        </div>
                    </div>
                </>:<>
                    <div className="form-row">
                        { hideTitleColumn  === false?<h1 className="col-12">{title}:</h1>:'' }
                        <div className="col-12">
                                { this.props.countryOptions &&
                                    <select className="s-form-control" name="country" key={ 'country_'+this.state.form.addressCountry} value={ this.state.form.addressCountry} onChange={ e => this.changeInputHandler(e, 'addressCountry') } required={true}>
                                        { this.props.countryOptions.map((item, key:number) => {
                                            return <option key={'country_'+key} value={item.value}>
                                                { item.label }
                                            </option>
                                        })}
                                    </select>
                                }
                        </div>
                    </div>
                    <div className="form-row">
                        { hideTitleColumn  === false?<div className="col-12"></div>:'' }
                        <div className="col-12">
                            <input className="s-form-control" type="text" name="state" value={this.state.form.addressState} onChange={ e => this.changeInputHandler(e,'addressState') } placeholder={Lng.get('state')} required={false}/>
                        </div>
                    </div>
                    <div className="form-row">
                        { hideTitleColumn  === false?<div className="col-12"></div>:'' }
                        <div className="col-12">
                            <input className="s-form-control" type="text" name="city" value={this.state.form.addressCity} onChange={ e => this.changeInputHandler(e,'addressCity') } placeholder={Lng.get('city')} required={true}/>
                        </div>
                    </div>
                    <div className="form-row">
                        { hideTitleColumn  === false?<div className="col-12"></div>:'' }
                        <div className="col-12">
                            <input className="s-form-control" type="text" name="street" value={this.state.form.addressStreet} onChange={ e => this.changeInputHandler(e,'addressStreet') } placeholder={Lng.get('street_house_number')} required={true}/>
                        </div>
                    </div>
                    <div className="form-row">
                        { hideTitleColumn  === false?<div className="col-12"></div>:'' }
                        <div className="col-6">
                            <input className="s-form-control" type="text" name="zip" value={this.state.form.addressZip} onChange={ e => this.changeInputHandler(e,'addressZip') } placeholder={Lng.get('zip')} required={true}/>
                        </div>
                        <div className="col-6">
                            <button className="green_btn" id="get_address_from_location_btn" type="button" onClick={ e => {
                                e.preventDefault();
                                this.getGeoLocation();
                            } }>{ this.state.loading===true?Lng.get('user_handover_loading'):Lng.get('use_my_location') }</button>
                        </div>
                    </div>

                </> }


            </div>
        );
    }
}
